module.exports = __webpack_public_path__ + "static/media/arrow.5d568719.svg";